import React from 'react'

const TermsConditions = () => {
  return (
    <div>
      <div className="max-w-4xl mx-auto p-8 bg-white rounded-2xl shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          Terms and Conditions
        </h1>
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              1. General Information
            </h2>
            <p>
              The trainee agrees to provide accurate and complete personal
              details during registration.
            </p>
            <p>
              The training schedule, including dates, timings, and locations,
              will be communicated in advance.
            </p>
            <p>
              NHWM reserves the right to reschedule sessions due to unforeseen
              circumstances (e.g., instructor unavailability or technical
              issues).
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-800">
              2. Course Fees and Payment Terms
            </h2>
            <p>
              As communicated, the selected candidates are required to pay the
              applicable course fees at the time of enrollment in the 3-month
              certificate course titled "Certificate in Principles of Applied
              Nutrition and Wellness.
            </p>
            <p>
              The fees paid towards the 3-month certificate course shall{" "}
              <strong>not be refunded under any circumstances</strong>,
              including withdrawal, discontinuation, or non-completion of the
              course.
            </p>
            <p>
              Any additional costs (including materials, asset security deposit,
              certifications, or examinations, if applicable) will be
              communicated in advance and must be borne by the candidate.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              3. Attendance and Participation
            </h2>
            <p>
              The trainee must attend all scheduled sessions and actively
              participate in training activities and assignments given during
              the training programme.
            </p>
            <p>
              Attendance must be 100% which is required to qualify for Training
              Completion Certification.
            </p>
            <p>
              Late arrivals or early departures may be recorded as
              non-eligibility for certification.
            </p>
            <p>
              Appointment Letters would not be generated for those candidates
              whose Training Completion Certificate is in hold.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              4. Code of Conduct
            </h2>
            <p>
              Trainees must behave professionally and respectfully toward
              instructors and fellow trainees.
            </p>
            <p>
              Any misconduct, including harassment, discrimination, or
              disruption, may result in removal from the training program.
            </p>
            <p>
              Unauthorized use of mobile phones or recording devices during
              training sessions is prohibited.
            </p>
            <p>
              No refunds will be issued in case of termination due to a breach
              of terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              5. Equipment and Property Usage
            </h2>
            <p>
              Any equipment, tools, instruments, or devices provided during the
              training must be handled with care.
            </p>
            <p>
              Trainees are responsible for returning borrowed items in good
              condition if asked by the Management of NHWM.
            </p>
            <p>
              Any damages caused due to negligence must be compensated by the
              trainee or will be deducted from the security money.
            </p>
            <p>
              During the training, any assignment given as homework or fieldwork
              must be completed on time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              6. Confidentiality Agreement
            </h2>
            <p>
              Trainees may have access to confidential information during
              training (e.g., patient data, business strategies).
            </p>
            <p>
              Disclosure or misuse of such information is strictly prohibited
              and may lead to legal consequences.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              7. Use of Candidate's Image, Videos or Testimonials
            </h2>
            <p>
              NHWM may use candidates' photographs, videos, testimonials, or
              feedback for marketing and promotional purposes at any time,
              regardless of whether they continue to be associated with NHWM.
              Submission of the course registration form shall be deemed as
              acceptance of these conditions and all the Terms and Conditions of
              NHWM and its parent company, OHWPL.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              8. Complaints and Grievance Redressal
            </h2>
            <p>
              No complaints regarding the training program will be entertained.
              The NHWM or any of its supportive bodies will not entertain any
              third party, be it a government or non-government, for addressing
              such conflicts.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              9. Use of Training Materials
            </h2>
            <p>
              All training materials, including handouts, videos, and software,
              are for personal use only.
            </p>
            <p>
              Trainees are not permitted to distribute, copy, or reproduce
              training content without written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              10. Health and Safety Compliance
            </h2>
            <p>
              Trainees must adhere to all safety protocols, especially when
              handling devices or instruments (if applicable).
            </p>
            <p>
              The training provider is not responsible for injuries resulting
              from non-compliance with safety guidelines.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              11. Certification and Evaluation
            </h2>
            <p>
              Successful completion of the training depends on performance in
              assessments, tests, and practical sessions/assignments.
            </p>
            <p>
              The training provider reserves the right to withhold certification
              if requirements are not met.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              12. Liability and Disclaimer
            </h2>
            <p>
              The training provider is not responsible for any loss, damage, or
              injury occurring during the training.
            </p>
            <p>
              The trainee acknowledges that participation is voluntary and at
              their own risk.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              13. Privacy and Data Protection
            </h2>
            <p>
              Personal data collected during registration will be used only for
              training-related purposes.
            </p>
            <p>
              Trainees' data will not be shared with third parties without
              consent, except as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              14. Amendments and Termination
            </h2>
            <p>
              The training provider reserves the right to modify terms and
              conditions at any time.
            </p>
            <p>
              Failure to comply with these terms may result in termination of
              training without a refund.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800">
              15. Governing Law and Jurisdiction
            </h2>
            <p>
              NHWM hopes that no disputes will arise between any candidate and
              the Management of NHWM. However, in the event of any dispute,
              every effort shall first be made to resolve the matter amicably
              through mutual understanding. If the dispute remains unresolved,
              it shall be subject to the exclusive jurisdiction of the courts at
              Guwahati, Assam.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsConditions